import {
  BooleanField,
  Datagrid,
  DateField,
  FunctionField,
  List,
  NumberField,
  TextField,
} from 'react-admin';
import { Chip } from '@mui/material';
import type { Template } from '../../types';
import { templateSource } from './templateSource';

export const TemplateList = () => (
  <List pagination={false} exporter={false} actions={false} sort={{ field: 'key', order: 'ASC' }}>
    <Datagrid rowClick="edit" bulkActionButtons={false}>
      <TextField source="key" label="Ключ" />
      <TextField source="name" label="Название" />
      <FunctionField<Template> label="Источник" render={(t) => templateSource(t)} />
      <FunctionField<Template>
        label="Репозиторий"
        render={(t) =>
          t.repoUrl ? (
            t.repoUrl
          ) : (
            <Chip size="small" color="warning" label="не задан" />
          )
        }
      />
      <FunctionField<Template> label="Окружения" render={(t) => (t.environments || ['prod']).join(', ')} />
      <NumberField source="clientsCount" label="Клиентов" />
      <BooleanField source="active" label="Активен" />
      <DateField source="updatedAt" label="Изменён" showTime />
    </Datagrid>
  </List>
);
